<div class='menu-basemap-gallery' #basemapGalleryDiv ></div>